export default __webpack_public_path__ + "static/BackgroundThankYou2024-929d03ad61be9fcc650895437e5582ec.png";